export class WidgetRegistry {
    defs = new Map();
    register(def) {
        if (this.defs.has(def.type)) {
            throw new Error(`WidgetRegistry: widget type "${def.type}" is already registered.`);
        }
        this.defs.set(def.type, def);
        return this;
    }
    get(type) {
        return this.defs.get(type);
    }
    has(type) {
        return this.defs.has(type);
    }
    types() {
        return [...this.defs.keys()];
    }
    /**
     * Render a single widget through its registered definition.
     * If the widget type is unknown, returns an HTML comment so malformed
     * pages don't crash the render - they degrade gracefully.
     */
    render(widget, ctx) {
        const def = this.defs.get(widget.type);
        if (!def) {
            return `<!-- unknown widget type: ${widget.type} -->`;
        }
        let props = widget.props;
        if (def.validate) {
            try {
                props = def.validate.parse(widget.props);
            }
            catch (err) {
                // biome-ignore lint/suspicious/noConsole: intentional dev signal
                console.warn(`[EmBuilder] invalid props for widget ${widget.id} (${widget.type}):`, err);
                props = def.defaultProps;
            }
        }
        return def.renderHtml(props, ctx);
    }
}
//# sourceMappingURL=registry.js.map